import React from 'react';
import { useSimulationContext } from '../providers/SimulationProvider';

function BrandBackdrop() {
  const { isClientInitialized } = useSimulationContext();

  // Unmount once a renderer is on top. This stops the spinner animation and
  // releases the decoded backdrop image, instead of leaving them behind an
  // element that already covers them.
  if (isClientInitialized) return null;

  return (
    <div className='fixed inset-0'>
      <img
        src='/BrandBackdrop.jpg'
        alt=''
        data-testid='brand-backdrop-image'
        className='absolute inset-0 w-full h-full object-cover'
      />

      <div className='absolute inset-0 flex items-center justify-center px-4'>
        {/*
          The row owns the font size. The indicator and the gap are sized in em,
          so both track the text instead of needing a value per breakpoint.
          4.25vw matches the proportions of the original artwork.
        */}
        <div
          role='status'
          aria-live='polite'
          className='flex items-center gap-[0.65em] text-[length:clamp(2rem,4.25vw,7rem)] leading-none text-white'
        >
          <div
            aria-hidden='true'
            data-testid='brand-backdrop-indicator'
            className='brand-glow-ring w-[1.1em] h-[1.1em] shrink-0 rounded-full border-[0.14em] border-white/30 border-t-white animate-spin'
          />
          <span className='brand-glow-text font-semibold tracking-wide'>
            Loading...
          </span>
        </div>
      </div>
    </div>
  );
}

export default BrandBackdrop;
